import React from 'react';
import LineChip from './LineChip';
import styles from './LineChip.module.css';

interface LineChipsGroupProps {
  lineNumbers: string[];
  size?: 'small' | 'normal' | 'large';
  maxVisible?: number;
  onLineClick?: (lineNumber: string) => void;
  className?: string;
}

/**
 * Birden fazla hat numarasını gösteren bileşen
 * @param lineNumbers - Hat numaraları dizisi
 * @param size - Hat çiplerinin boyutu
 * @param maxVisible - Gösterilecek maksimum hat sayısı
 * @param onLineClick - Hat çipine tıklandığında çalışacak fonksiyon
 * @param className - Ek CSS sınıfı
 */
const LineChipsGroup: React.FC<LineChipsGroupProps> = ({
  lineNumbers,
  size = 'normal',
  maxVisible = 5,
  onLineClick,
  className = '',
}) => {
  if (!lineNumbers || lineNumbers.length === 0) {
    return null;
  }
  
  // Görünecek hat sayısını sınırla
  const visibleLines = lineNumbers.slice(0, maxVisible);
  const hasMoreLines = lineNumbers.length > maxVisible;
  
  return (
    <div className={`${styles.lineChipsContainer} ${className}`}>
      {visibleLines.map((line) => (
        <LineChip
          key={line}
          lineNumber={line}
          size={size}
          onClick={onLineClick ? () => onLineClick(line) : undefined}
        />
      ))}
      
      {hasMoreLines && (
        <div className={`${styles.lineChip} ${styles[size]}`}>
          +{lineNumbers.length - maxVisible}
        </div>
      )}
    </div>
  );
};

export default LineChipsGroup;
